import type { CityConfig } from "../city-template/types";

export const richmondVaConfig: CityConfig = {
  city: "Richmond",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "richmond-va",
  route: "/cities/richmond-va",
  title: "Emergency Passport Richmond, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Richmond, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Henrico, Chesterfield, Hanover, and the Greater Richmond metro area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Richmond, VA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Richmond and the Greater Richmond metro area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20photograph%20of%20Richmond%20Virginia%20skyline%20at%20golden%20hour%20with%20the%20Virginia%20State%20Capitol%20building%20visible%2C%20modern%20and%20historic%20architecture%20along%20the%20James%20River%2C%20warm%20amber%20sunlight%20reflecting%20on%20the%20water%2C%20lush%20green%20tree%20canopy%20in%20the%20foreground%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20sharp%20architectural%20details%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=richmond-va-hero-001&orientation=landscape",
  heroImageAlt: "Richmond Virginia downtown skyline at golden hour with the Virginia State Capitol and James River",
  geoPosition: "37.5407;-77.4360",
  geoPlacename: "Richmond, Virginia",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 110 miles from Richmond via I-95",
  },
  nearbyCitiesZips: [
    { name: "Richmond", zips: "23219–23242" },
    { name: "Henrico", zips: "23228–23294" },
    { name: "Chesterfield", zips: "23831–23838" },
    { name: "Hanover", zips: "23005, 23069, 23047" },
    { name: "Petersburg", zips: "23803, 23804, 23805" },
    { name: "Hopewell", zips: "23860" },
    { name: "Colonial Heights", zips: "23834" },
    { name: "Glen Allen", zips: "23059, 23060" },
    { name: "Midlothian", zips: "23112, 23113, 23114" },
    { name: "Mechanicsville", zips: "23111, 23116" },
    { name: "Short Pump", zips: "23060" },
    { name: "Ashland", zips: "23005" },
    { name: "Chester", zips: "23831, 23836" },
    { name: "Charlottesville", zips: "22901–22911" },
    { name: "Williamsburg", zips: "23185, 23188" },
    { name: "Newport News", zips: "23601–23609" },
    { name: "Norfolk", zips: "23501–23523" },
    { name: "Virginia Beach", zips: "23450–23479" },
    { name: "Fredericksburg", zips: "22401–22408" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Richmond departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Capital Region Hub", desc: "Serving Richmond, Henrico, Chesterfield, and the entire metro area" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Richmond from our local office at 7272 Wisconsin Ave in Bethesda, Maryland — about 110 miles north of Richmond. Visit us by appointment, or use our courier pickup throughout the Greater Richmond metro area.",
  fpcOfficeDistance: "7272 Wisconsin Ave, Bethesda, Maryland 20814 (approx. 110 miles from Richmond)",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  serviceAreaIntro: "From downtown Richmond's historic Fan District to the suburbs of Henrico, Chesterfield, and Hanover, from the James River to the Tri-Cities — Fast Passport Center serves the entire Greater Richmond region. We regularly help travelers from Charlottesville, Williamsburg, Newport News, and Fredericksburg get their passports fast.",
  nearbyCitiesIntro: "We serve all Richmond neighborhoods and the surrounding metro area including Henrico, Chesterfield, Hanover, Petersburg, Hopewell, Colonial Heights, Glen Allen, Midlothian, Mechanicsville, Short Pump, Ashland, Chester, Charlottesville, Williamsburg, Newport News, Norfolk, Virginia Beach, and Fredericksburg. If you are anywhere in the Greater Richmond metropolitan area, we have you covered.",
  howItWorksIntro: "Most Richmond travelers complete everything online and ship documents overnight. No need to drive to Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Richmond travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Richmond and Greater Richmond metro area travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Richmond? Here are the most common ones we hear from Greater Richmond travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Richmond and Central Virginia residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Richmond Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.rva.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Richmond Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.rva.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Richmond international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Amanda R.",
      location: "Richmond, VA",
      rating: 5,
      text: "My passport expired the week before a business trip to London. Fast Passport Center had my renewal ready in 4 days. I never had to leave Richmond. Absolutely incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "James T.",
      location: "Henrico, VA",
      rating: 5,
      text: "Emergency passport for a family emergency in Germany. Got it in 36 hours. The team kept me updated every step. I was amazed this could happen without driving to DC.",
      service: "Emergency Passport",
    },
    {
      name: "Michelle L.",
      location: "Midlothian, VA",
      rating: 5,
      text: "First passport for my 10-year-old before our cruise to the Caribbean. Fast Passport Center walked us through every document and had her passport ready in 5 days. Stress-free from start to finish.",
      service: "Child Passport",
    },
    {
      name: "Robert H.",
      location: "Chesterfield, VA",
      rating: 5,
      text: "Lost my passport 4 days before a conference in Tokyo. Fast Passport Center had a replacement in my hands in 30 hours. These guys are lifesavers.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "richmond-va-1",
      name: "Richmond Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1801 Brook Rd",
      city: "Richmond",
      state: "VA",
      zip: "23220",
      phone: "(804) 775-2381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Richmond, near Virginia Union University",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Richmond facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "richmond-va-2",
      name: "Henrico County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "4301 E Parham Rd",
      city: "Henrico",
      state: "VA",
      zip: "23228",
      phone: "(804) 501-4207",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Henrico County Government Center",
      website: "https://henrico.us/",
      websiteLabel: "Henrico County Clerk",
      notes: "Major county facility for Henrico County. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "richmond-va-3",
      name: "Chesterfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7001 Walmsley Blvd",
      city: "Richmond",
      state: "VA",
      zip: "23235",
      phone: "(804) 276-2603",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Richmond, Chesterfield County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chesterfield County and south Richmond. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "richmond-va-4",
      name: "Hanover County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "7497 County Complex Rd",
      city: "Hanover",
      state: "VA",
      zip: "23069",
      phone: "(804) 365-6151",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Hanover County Government Complex",
      website: "https://www.hanovercounty.gov/",
      websiteLabel: "Hanover County Clerk",
      notes: "Serves Hanover County and north Richmond area. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "richmond-va-5",
      name: "Petersburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "319 N Adams St",
      city: "Petersburg",
      state: "VA",
      zip: "23803",
      phone: "(804) 733-3241",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Petersburg, Tri-Cities area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Petersburg, Colonial Heights, and Hopewell. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "richmond-va-6",
      name: "Charlottesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1155 Seminole Trl",
      city: "Charlottesville",
      state: "VA",
      zip: "22901",
      phone: "(434) 973-2316",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "70 miles west of Richmond",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Charlottesville and Albemarle County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2 hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Richmond photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Greater Richmond acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Richmond applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Greater Richmond families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Richmond travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Richmond." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Richmond address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Richmond before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Richmond for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 2 hour drive to Washington, DC." },
    { q: "How fast can I renew my passport in Richmond?", a: "Fast Passport Center offers fast passport renewal in Richmond in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Richmond?", a: "The nearest regional passport agency to Richmond is the Washington Passport Agency, approximately 110 miles away via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Richmond without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Richmond?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency — approximately 2 hours from Richmond — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Richmond residents." },
    { q: "Can I expedite a child passport in Richmond?", a: "Yes. Fast Passport Center expedites child passports in Richmond for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Greater Richmond families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Richmond with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Richmond?", a: "With Fast Passport Center's emergency courier service, Richmond travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Richmond?", a: "Popular options include the Richmond Main Post Office (23220), Henrico County Clerk (23228), Chesterfield Post Office (23235), Hanover County Clerk (23069), Petersburg Post Office (23803), and Charlottesville Post Office (22901). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Richmond?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 2 hour drive to DC." },
    { q: "What if I live in a smaller Central Virginia town?", a: "We serve the entire Greater Richmond area and surrounding communities including Henrico, Chesterfield, Hanover, Petersburg, Hopewell, Colonial Heights, Glen Allen, Midlothian, Mechanicsville, Short Pump, Ashland, Chester, Charlottesville, Williamsburg, and Fredericksburg. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Richmond?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Richmond?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and Walmart locations in Richmond and Henrico offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Richmond?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Richmond?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Greater Richmond families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Richmond", address: "5001 W Broad St, Richmond, VA 23230", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Richmond", address: "5700 Patterson Ave, Richmond, VA 23226", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Richmond", address: "900 Walmart Way, Richmond, VA 23235", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Richmond", address: "1100 Cary St, Richmond, VA 23220", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Henrico", address: "9004 W Broad St, Richmond, VA 23294", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Chesterfield", address: "12300 Bermuda Cross Rd, Chester, VA 23836", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Midlothian", address: "900 Walmart Way, Midlothian, VA 23113", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Glen Allen", address: "11055 W Broad St, Glen Allen, VA 23060", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Richmond North",
      address: "2300 W Broad St, Richmond, VA 23220",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Richmond South",
      address: "9107 Midlothian Tpke, Richmond, VA 23235",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Henrico",
      address: "8500 Bell Creek Rd, Henrico, VA 23238",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves western Henrico and Glen Allen residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Chesterfield",
      address: "6300 Midlothian Tpke, Richmond, VA 23225",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Chesterfield County and south Richmond. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "7 miles east of downtown Richmond",
      address: "1 Richard E Byrd Terminal Dr, Richmond, VA 23250",
      note: "The primary airport for the Greater Richmond region. Direct flights to major domestic destinations and international connections.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: true,
    },
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "110 miles north of Richmond",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for long-haul flights to Europe, Asia, and the Caribbean. Accessible via I-95 and I-66.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "DCA",
      name: "Reagan National Airport",
      distance: "105 miles north of Richmond",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Alternative major international hub for international flights. Accessible via I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
  ],
};